// TODO: Remove when update of attrivutes is handeled by backend API
// For more information see comments https://eriksdigital.atlassian.net/browse/GB-713

import { Attributes } from 'app/features/attributes/slice/types';

export const checkValues = (attributes: Attributes, values: {}) => {
  // This function is normalising attributes array and creates attributes object so that can
  // be matched with form values object
  const modifiedAttr =
    attributes &&
    Object.entries(attributes).map(([key, value]) => {
      return { [key]: value.map((item: { value: string }) => item.value) };
    });

  const attributesObject = modifiedAttr && Object.assign({}, ...modifiedAttr);

  //Matching attributes object and form values object and push it to new array of values
  // that will be used for payload in sagas (items and attributes)
  let arr: { [key: string]: string[] }[] = [];
  if (attributesObject) {
    for (const [key, value] of Object.entries(attributesObject)) {
      const result =
        values[key] &&
        values[key].filter((i: string) => {
          return (value as string[]).includes(i);
        });
      const attr = { [key]: result };
      result && arr.push(attr);
    }
  }

  return Object.assign({}, ...arr);
};
